module.exports = __webpack_public_path__ + "static/img/product_society_develop.d21fa83.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_society_develop.png
// module id = y9Rc
// module chunks = 0